import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function ThankYou() {
    // Basic per-page SEO — do NOT index this confirmation page.
    useEffect(() => {
        const prevTitle = document.title;
        document.title = "Thank you — Adx Fusion";

        const robots = document.createElement("meta");
        robots.name = "robots";
        robots.content = "noindex, nofollow";
        document.head.appendChild(robots);

        return () => {
            document.title = prevTitle;
            robots.remove();
        };
    }, []);

    return (
        <div>
            <section className="container-x pt-24 pb-12">
                <p className="overline mb-8" data-testid="thank-you-eyebrow">Chapter 05 · Contact</p>
                <Reveal>
                    <div
                        className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-primary/15 border border-brand-primary/40 mb-10"
                        aria-hidden="true"
                    >
                        <Check className="w-8 h-8 text-brand-primary" />
                    </div>
                    <h1
                        className="font-display leading-[0.9] tracking-tighter"
                        style={{ fontSize: "clamp(2rem, 6vw, 5rem)" }}
                        data-testid="thank-you-heading"
                    >
                        Thank you.{" "}
                        <span className="italic text-brand-primary">We&apos;ve got your brief.</span>
                    </h1>
                </Reveal>
                <Reveal delay={120} className="mt-10 max-w-3xl">
                    <p className="text-xl text-brand-frost/85 leading-relaxed" data-testid="thank-you-body">
                        Your submission has been received. A senior strategist will be in touch within one business day. In the meantime, take a look at the work we&apos;ve shipped for other financial and trading brands.
                    </p>
                </Reveal>
            </section>

            <section className="border-y border-brand-primary/10">
                <div className="container-x py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                    <div className="lg:col-span-7">
                        <Reveal>
                            <p className="overline mb-6">While you wait</p>
                            <h2 className="font-display h-display-md text-brand-mist">
                                See what we&apos;ve done for firms like yours.
                            </h2>
                            <p className="mt-6 text-brand-frost/85 leading-relaxed max-w-2xl">
                                Deep-dive case studies from Vantage Markets, Scope Markets, MultiBank Group and OneRoyal — with the briefs, our approach, and the numbers we shipped.
                            </p>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col gap-4 lg:items-end">
                        <Link
                            to="/snapshot"
                            data-testid="thank-you-see-work"
                            className="btn-primary"
                        >
                            See our work <ArrowUpRight className="w-4 h-4" />
                        </Link>
                        <Link
                            to="/"
                            data-testid="thank-you-home"
                            className="btn-secondary"
                        >
                            Back to home
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
